import { render, staticRenderFns } from "./region-map.vue?vue&type=template&id=5ae54b4a&scoped=true&"
import script from "./region-map.vue?vue&type=script&lang=js&"
export * from "./region-map.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae54b4a",
  null
  
)

export default component.exports